import script from "./images.vue?vue&type=script&setup=true&lang=ts"
export * from "./images.vue?vue&type=script&setup=true&lang=ts"

import "./images.vue?vue&type=style&index=0&id=19a1b452&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a1b452"]])

export default __exports__